import { syncStorage } from "../app/storage";
export const initialize = () => {
  syncStorage()
}